import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, CheckboxModule, InputModule, SelectDateYmModule, SelectModule } from '@lib/components';
import { ServiceRequestPaymentInputCreditCardComponent } from './service-request-payment-input-credit-card.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [ServiceRequestPaymentInputCreditCardComponent],
  exports: [ServiceRequestPaymentInputCreditCardComponent],
  imports: [
    CommonModule,
    InputModule,
    SelectModule,
    StaticMsgModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    SelectDateYmModule,
    ButtonModule,
  ],
})
export class ServiceRequestPaymentInputCreditCardModule {}
